<template>
    <v-data-table class="elevation-0"
                  :headers="headers"
                  :items="items"
                  :items-per-page="15"
                  :footer-props="dataTableFooterProps"
                  :search="dataTableSearch"
                  :custom-filter="dataTableCustomFilter"
                  :loading="isBusy"
                  :loading-text="$t('common.loading_table_data')"
    >
        <template v-slot:item.warehouse_count="{ item }">
            {{ item.warehouse_count }}
        </template>
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-text-field
                    v-model="dataTableSearch"
                    prepend-inner-icon="mdi-magnify"
                    :placeholder="$t('common.filter')"
                    outlined
                    dense
                    hide-details
                />
                <v-spacer/>
                <p class="mr-3 mt-2">
                    <v-icon>
                        {{ synchronizationIcon(synchronization) }}
                    </v-icon>
                    {{ synchronization ? $t('synchronization.status.' + synchronization.status) : '-' }}
                    ({{ synchronization ? $moment(synchronization.date_time).format('LLL') : '-' }})
                    <span v-if="synchronization && synchronization.status === 'error' && synchronization.error" class="error--text">
                        - {{ synchronization.error }}
                    </span>
                </p>
                <v-btn
                    v-if="!synchronization || (synchronization.status !== 'waiting' && synchronization.status !== 'synchronizing')"
                    color="success"
                    dark
                    class="mb-2"
                    @click="onSynchronize"
                    :loading="isBusySynchronize"
                >
                    {{ $t('button.synchronize') }}
                </v-btn>
            </v-toolbar>
        </template>
    </v-data-table>
</template>

<script>
import {API} from "@/api/api";
import SnackbarMixin from "@/mixins/SnackbarMixin";
import SynchronizationMixin from "@/mixins/SynchronizationMixin";
import DataTableMixin from "@/mixins/DataTableMixin";

export default {
    name: 'BrandsTableComponent',
    mixins: [SnackbarMixin, SynchronizationMixin, DataTableMixin],
    data: () => ({
        // loading
        isBusyBrands: false,
        isBusySynchronize: false,
        isBusySynchronization: false,
        // table data
        items: [],
        // synchronization data
        synchronization: null
    }),
    computed: {
        isBusy() {
            return this.isBusyBrands || this.isBusySynchronize || this.isBusySynchronization;
        },
        headers() {
            return [
                {
                    text: this.$t('brands.name'),
                    value: 'name'
                },
                {
                    text: this.$t('brands.warehouses_count'),
                    value: 'warehouse_count'
                }
            ];
        }
    },
    methods: {
        fetchBrands() {
            this.isBusyBrands = true;
            API.get('/api/brands')
                .then(response => {
                    this.items = response.data.map(brand => ({
                        ...brand,
                        warehouse_count: brand.warehouse_ids.length
                    }));
                })
                .catch(error => {
                    this.snackbarError(error);
                })
                .finally(() => {
                    this.isBusyBrands = false;
                });
        },
        fetchSynchronization() {
            this.isBusySynchronization = true;
            API.get('/api/synchronizations/brand')
                .then(response => {
                    this.synchronization = response.data;
                })
                .catch(error => {
                    this.snackbarError(error);
                })
                .finally(() => {
                    this.isBusySynchronization = false;
                });
        },
        onSynchronize() {
            this.isBusySynchronize = true;
            API.post('/api/brands/synchronize', [])
                .then(() => {
                    this.snackbarSuccess(this.$t('snackbar.brands.synchronized'));
                    this.fetchBrands();
                    this.fetchSynchronization();
                })
                .catch(error => {
                    this.snackbarError(error);
                })
                .finally(() => {
                    this.isBusySynchronize = false;
                })
        }
    },
    created() {
        this.fetchBrands();
        this.fetchSynchronization();
    }
}
</script>
